
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDisplayBrillianceLow as ObiDisplayBrillianceLowElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-display-brilliance-low.js';
 
 
 

 
 export const ObiDisplayBrillianceLow = createComponent({
   react: React,
   tagName: 'obi-display-brilliance-low',
   elementClass: ObiDisplayBrillianceLowElement,
   events: {
     
   }
  });
 
 